(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vvv-card-video')) {
    customElements.define('vvv-card-video', class extends HTMLElement {
      connectedCallback() {
        if (this.video) return;
        this.video = this.querySelector('video');
        this.card = this.closest('.product-item');
        this.button = this.card.querySelector('.vvv-card-video-toggle');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.stopped = false;
        this.changed = false;
        this.video.muted = true;
        this.video.playsInline = true;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.video.addEventListener('playing', () => {
          this.setAttribute('data-ready', '');
          this.button.hidden = false;
        }, options);
        this.video.addEventListener('error', () => {
          this.removeAttribute('data-ready');
          this.button.hidden = true;
        }, options);
        this.button.addEventListener('click', () => {
          this.stopped = !this.stopped;
          this.button.setAttribute('aria-pressed', String(this.stopped));
          this.button.querySelector('span').textContent = this.stopped ? '▶' : 'Ⅱ';
          this.update();
        }, options);
        this.card.addEventListener('click', event => {
          if (event.target.closest('.color-option-btn')) {
            this.changed = true;
            this.removeAttribute('data-ready');
            this.button.hidden = true;
            this.update();
          }
        }, options);
        document.addEventListener('visibilitychange', () => this.update(), options);
        this.motion.addEventListener('change', () => this.update(), options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.update();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      }
      update() {
        if (this.visible && !this.stopped && !this.changed && !this.motion.matches && !document.hidden) {
          const attempt = this.video.play();
          if (attempt) attempt.catch(() => {});
        } else {
          this.video.pause();
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.video?.pause();
        this.video = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
